import React, { useContext, useState } from 'react';

import { AlertaContexto, useToast } from '.';

export interface Props {
    titulo?: string;
    conteudo: string;
    aoConfirmar: () => void;
}

const Confirmacao = ({ titulo, conteudo, aoConfirmar }: Props): React.ReactElement =>
{
    const toast = useToast();
    const { setConfirmacao } = useContext(AlertaContexto);
    const [ processando, setProcessando ] = useState<boolean>(false);

    const confirmar = async (): Promise<void> =>
    {
        try {
            setProcessando(true);

            await aoConfirmar();

            setConfirmacao(null);
        } catch (erro) {
            toast({
                titulo: 'Erro',
                conteudo: 'Verifique os logs para mais detalhes.',
                tema: 'danger',
            });
        }
    }

    return (
        <React.Fragment>
            <div className="modal show animate__animated animate__fadeIn animate__faster d-block">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0">
                        { titulo && (
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    { titulo }
                                </h5>
                            </div>
                        ) }
                        <div className="modal-body">
                            { conteudo }
                        </div>
                        <div className="modal-footer">
                            <button
                                className={ `btn btn-light ${processando ? 'disabled' : ''}` }
                                onClick={ () => setConfirmacao(null) }
                            >
                                Cancelar
                            </button>
                            <button
                                className={ `btn btn-primary ${processando ? 'disabled' : ''}` }
                                onClick={ confirmar }
                            >
                                <React.Fragment>
                                    { processando && (
                                        <React.Fragment>
                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                            Aguarde...
                                        </React.Fragment>
                                    ) }
                                    { !processando && 'Confirmar' }
                                </React.Fragment>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </React.Fragment>
    )
}

export default Confirmacao;
